import type { CSSProperties } from "react";

export function getCreferenceLinkedLabelTextStyle(): CSSProperties {
  return {
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    minWidth: 0,
    maxWidth: "100%",
  };
}
